import Photo from "shared/components/data-display/media/Photo";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const StyledImg = styled(Photo)`
    width: 44px;
    height: 44px;
    object-fit: cover;
`;

export const EmployeeCard = styled.div`
    padding: 16px;
    border: 1px solid ${COLOR_VALUES.Gray_7};
    border-radius: 4px;
`;
